import { FunctionComponent } from 'preact';
import BuyingOptionsTableHead from './BuyingOptionsTableHead';
import BuyingOptionsTableColourCell from './BuyingOptionsTableColourCell';
import BuyingOptionsTableVariantCell from './BuyingOptionsTableVariantCell';
import { BasketItem } from '../types';
import { ProductVariant, Image } from '../types';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';

const BuyingOptionsTable: FunctionComponent<BuyingOptionsTableProps> = ({
    productVariants,
    images,
    isSpecialKnitwear,
    productBasket,
    multiple,
    isProcessing,
    onChangeQuantity,
    scrollRight,
    nextButtonIsDisabled,
    stickyTableVisibility,
    isSchoolPage,
    hidePrices
}) => {
    const sizeOptions = uniq(productVariants.map(pv => pv.size));
    const colourOptions = uniqBy(productVariants.map(pv => ([ pv.colour, pv.colour_value ])), 0);

    return (
        <>
            <div
                class="buying-options__table-container buying-options__table-container--normal"
                data-buying-options-container
            >
                <table class="buying-options__table" data-table-normal-head>
                    <BuyingOptionsTableHead sizeOptions={sizeOptions} />
                    <tbody>
                        {colourOptions.map(([ colour, colour_value ]) => {
                            const productVariantsOfColour = productVariants.filter(
                                pv => pv.colour === colour || pv.colour_value === colour_value
                            );
                            const colourImage = images.find(i => i.colour === colour || i.colour === colour_value);

                            return (
                                <tr class="buying-options__table-row">
                                    <BuyingOptionsTableColourCell
                                        colour={colour}
                                        image={colourImage}
                                    />
                                    {sizeOptions.map(size => {
                                        const productVariantOfColourAndSize = productVariantsOfColour.find(
                                            pv => pv.size === size
                                        );
                                        if (productVariantOfColourAndSize === undefined) {
                                            return (
                                                <td class="buying-options__table-variant-cell">
                                                    &nbsp;
                                                </td>
                                            );
                                        }
                                        const productVariantOfColourInBasket = productBasket.filter(
                                            pv => pv.colour === colour
                                        );
                                        const productVariantOfColourAndSizeInBasket =
                                            productVariantOfColourInBasket !== undefined
                                                ? productVariantOfColourInBasket.find(
                                                      pv => pv.size === size
                                                  )
                                                : undefined;

                                        return (
                                            <BuyingOptionsTableVariantCell
                                                key={productVariantOfColourAndSize.sku}
                                                productVariant={productVariantOfColourAndSize}
                                                isSpecialKnitwear={isSpecialKnitwear}
                                                quantityInBasket={
                                                    productVariantOfColourAndSizeInBasket?.quantity
                                                }
                                                multiple={multiple}
                                                isProcessing={isProcessing}
                                                hidePrices={hidePrices}
                                                onChangeQuantity={onChangeQuantity}
                                            />
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <button
                    class={`table-arrow-button ${nextButtonIsDisabled ? 'd-none' : ''}`}
                    onClick={() => {
                        scrollRight();
                    }}
                >
                    <span class="sr-only">Next Size</span>
                </button>
            </div>
            {isSchoolPage === false ? (
                <div
                    class="buying-options__table-container buying-options__table-container--sticky container"
                    data-buying-options-container-sticky
                >
                    <table
                        class={`buying-options__table-head-sticky row ${
                            stickyTableVisibility ? 'd-inline' : ''
                        }`}
                        aria-hidden="true"
                        data-table-sticky-head
                    >
                        <BuyingOptionsTableHead sizeOptions={sizeOptions} />
                    </table>
                </div>
            ) : null}
        </>
    );
};

interface BuyingOptionsTableProps {
    productVariants: ProductVariant[];
    images: Image[];
    isSpecialKnitwear: boolean;
    productBasket: BasketItem[];
    multiple: number;
    isProcessing: boolean;
    onChangeQuantity: (productVariant: ProductVariant, quantity: number) => void;
    scrollRight: () => void;
    nextButtonIsDisabled: boolean;
    stickyTableVisibility: boolean;
    isSchoolPage: boolean;
    hidePrices: boolean;
}

export interface Option {
    name: string;
    value: string;
    enabled: boolean;
}

export default BuyingOptionsTable;
